<template>
  <div>
    <div class="audience">
      <p class="level-2">定向人群</p>
      <el-radio-group v-model="form.directional" size="medium">
        <el-radio-button label="智能推荐"></el-radio-button>
        <el-radio-button label="自定义人群"></el-radio-button>
      </el-radio-group>

      <right-card :form="form" />
    </div>

    <custom-audience :form="form" v-show="form.directional == '自定义人群'" />
  </div>
</template>

<script>
import customAudience from "./customAudience.vue";
import RightCard from "./rightCard.vue";
export default {
  components: { customAudience, RightCard },
  props: {
    form: Object,
  },
};
</script>

<style lang="less" scoped>
.audience {
  position: relative;
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
}
</style>